import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import ForgetPassword from '../views/ForgetPassword.vue'
import Nofound from '../views/Nofound.vue'
import Member from '../views/Member.vue'
import Infor from '../components/Infor.vue'
import Award from '../components/award.vue'
import account from '../components/account'
import Apply from '../components/apply'
import Upgrade from '../components/upgrade'
import Declear from '../components/declear'
import DeclarRecord from '../components/DeclarRecord'
import Record from '../components/record'
import Performance from '../components/performance'
import Highquality from '../components/highquality'
import News from '../components/news'
import Feedback from '../views/Feedback'
import myform from '../components/myform'
import word_1 from '../components/word/word_1'
import word_2 from '../components/word/word_2'
import gfinfo from '../components/word/gfinfo'
import word_eproject from '../components/word/word_eproject'
import applymembership from '../components/Modal/applymembership.vue'
import Performancedeclaration from '../components/Modal/Performancedeclaration'
import Highqualitydeclaration from '../components/Modal/Highqualitydeclaration'
import expert from '../views/expert'
import Reviewrecords from '../components/Reviewrecords'
import Awardbatch from '../components/expert/AwardBatch'
import Awardlogreview from '../components/expert/AwardLogreview'
import Eprojectrecords from '../components/Eprojectrecords'
import Awardreview from '../components/Awardreview'
import expertMember from '../views/expertMembers'
import expertMembergf from '../views/expertMembersgf'
import expertpwd from '../components/expertpwd'
import uploadAppendix from '../components/uploadAppendix'
import renew from '../views/renew'
import EprojectDeclear from '../components/eprojectDeclear'
import epform from '../components/epform'
import eresetpwd from '../components/eresetpwd'
import EdeclarRecord from '../components/EdeclarRecord'
import Gflogs from '../components/Gflogs'
import Certificates from '../components/CertificatesSummary'
import CertificatesList from '../components/Certificates'
import CertificatesPreview from '../components/CertificatesPreview'
import CertificatesDownload from '../components/CertificatesDownload'
import PublicityConfirm from '../views/PublicityConfirm'
import PublicCertificatePreview from '../views/PublicCertificatePreview'


Vue.use(VueRouter)

const routes = [{
    path: '/',
    component: Login
}, {
    path: '/login',
    component: Login
},
    {
        path: '/register',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: Register
    },
    
    {
        path: '/forgetPassword',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: ForgetPassword
    },
    {
        path: '/nofound',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: Nofound
    }, {
        path: '/feedback',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: Feedback
    },
    {
        path: '/public/certificate/preview',
        component: PublicCertificatePreview
    },
    {
        path: '/form',
        component: myform
    },
    {
        path: '/epform',
        component: epform
    },
    {
        path: '/word_1',
        component: word_1
    },
    {
        path: '/ginfo',
        component: gfinfo
    },
    {
        path: '/word_2',
        component: word_2
    },
    {
        path: '/word_eproject',
        component: word_eproject
    },
    
    {
        path: '/applymembership',
        component: applymembership
    },
    {
        path: '/Performancedeclaration',
        component: Performancedeclaration
    },
    {
      path:'/Highqualitydeclaration',
      component: Highqualitydeclaration
    },
    {
        path: '/expert',
        component: expert
    },
    {
        path: '/expertmember',
        component: expertMember,
        children: [
            
            {
                path: 'Awardbatch',
                component: Awardbatch
            },
            {
                path: 'Reviewrecords',
                component: Reviewrecords
            },
            {
                path: 'Awardreview',
                component: Awardreview,
                 meta: {
                    isUseCache: false, // 默认不缓存
                    keepAlive: true,
                  }
            },
            
            {
                path: 'Eprojectrecords',
                component: Eprojectrecords,
                 meta: {
                    isUseCache: false, // 默认不缓存
                    keepAlive: true,
                  }
            },
            {
                path: 'expertpwd',
                component: expertpwd
            },
            {
                path: 'eresetpwd',
                component: eresetpwd
            }
        ]
    },
    {
        path: '/expertmembergf',
        component: expertMembergf,
        children: [
            {
                path: 'Awardbatch',
                component: Awardbatch
            },
            
            {
                path: 'Awardlogreviewunchecked',
                component: Awardlogreview,
                props: true ,  // 把 :status 自动作为 props 传进组件

                 meta: {
                    isUseCache: false, // 默认不缓存
                    keepAlive: true,
                  }
            },
             {
                path: 'Awardlogreviewchecked',
                component: Awardlogreview,
                props: true ,  // 把 :status 自动作为 props 传进组件

                 meta: {
                    isUseCache: false, // 默认不缓存
                    keepAlive: true,
                  }
            }
        ]
    },
    {
        path: '/gfprize',
        component: expertMembergf,
        children: [
            {
                path: 'Awardbatch',
                component: Awardbatch
            }
        ]
    },
    {
        path: '/member',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: Member,
        children: [{
            path: 'infor',
            component: Infor
        },
            {
            path: 'renew',
                component: renew
            },
                {
                path: 'award',
                component: Award
            },
            {
                path: 'apply',
                component: Apply
            },
            {
                path: 'upgrade',
                component: Upgrade
            },
            {
                path: 'declear',
                component: Declear
            },
            {
                path: 'Declar_record',
                component: DeclarRecord
            },
            {
                path: 'publicity_confirm',
                component: PublicityConfirm
            },
            {
                path: 'uploadAppendix',
                component: uploadAppendix
            },
            {
                path: 'record',
                component: Record
            },
            {
                path: 'performance',
                component: Performance
            },
            {
                path:'highquality',
                component: Highquality
            },
            {
                path: 'news',
                component: News
            },
            {
                path: 'account',
                component: account
            },
            {
                path: 'eprojectdeclear',
                component: EprojectDeclear
            },
            {
                path: 'edeclarrecord',
                component: EdeclarRecord
            },
            {
                path: '/gflogs',
                component: Gflogs
            },
            {
                path: 'certificates',
                component: Certificates
            },
            {
                path: 'certificates/list',
                component: CertificatesList
            },
            {
                path: 'certificates/preview',
                component: CertificatesPreview
            },
            {
                path: 'certificates/download',
                component: CertificatesDownload
            },

        ]
    },
    {
        path: '*', // 页面不存在的情况下会跳到404页面
        redirect: '/nofound',
        hidden: true
    }
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


const router = new VueRouter({
    routes
})

//路由导航守卫
router.beforeEach((to, from, next) => {
    if (window._hmt) {
        if (to.path) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
    }
    if (to.path == '/' || to.path == '/forgetPassword' || to.path == '/register' || to.path == '/word_1'|| to.path == '/word_2' || to.path == '/expert' || to.path == '/ginfo' || to.path == '/public/certificate/preview') {
        next()
    } else {
        const tokenstr = window.localStorage.getItem('TOKEN')
        if (tokenstr == null) {
            next('/')
        }
    }
    next()
})

export default router
